import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function TechStackCombobox({
    filter,
    hideLabel,
    className = "w-full",
    ...props
}) {
    if (hideLabel) {
        return (
            <div className={className}>
                <DirectusCombobox
                    client={client}
                    collection="tech_stack"
                    fields={["id", "name"]}
                    searchKeys={["name"]}
                    filter={filter}
                    placeholder="Select tech stack"
                    {...props}
                />
            </div>
        );
    }

    return (
        <FilterWrapper label="Tech Stack" className={className}>
            <DirectusCombobox
                client={client}
                collection="tech_stack"
                fields={["id", "name"]}
                searchKeys={["name"]}
                filter={filter}
                {...props}
            />
        </FilterWrapper>
    );
}
